import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import { Card, IconButton, Tooltip, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import Markdowner from "./Markdowner";
import AudioPlayer from "./AudioPlayer";
import cogoToast from "cogo-toast";
import Iconify from "src/components/iconify";

class AsstMessage extends React.Component {
  state = {
    audioFileURL: "",
  };
  componentDidMount() {
    if (this.props.isUnAuth) {
      if (this.props.message.genAudioUrl) {
        this.setState({ audioFileURL: this.props.message.genAudioUrl });
      } else {
        this.setState({
          audioFileURL: null,
        });
      }
    } else {
      this.startPolling();
    }
  }
  componentWillUnmount() {
    this.stopPolling();
  }
  startPolling = () => {
    this.pollInterval = setInterval(this.checkAudioFile, 1000);
  };
  stopPolling = () => {
    clearInterval(this.pollInterval);
  };
  checkAudioFile = async () => {
    if (this.props.message.genAudioUrl) {
      this.setState({ audioFileURL: this.props.message.genAudioUrl });
      this.stopPolling();
    } else {
      const audioFileURL = await this.getAudioFile();
      if (audioFileURL) {
        this.setState({ audioFileURL });
        this.stopPolling();
      }
    }
  };
  getAudioFile = async () => {
    try {
      let res = await this.props.apiCallPost("/harley/pollGenAudio", {
        messageId: this.props.message._id,
        threadId: this.props.threadId,
      });
      if (res && res.genAudioUrl) {
        return res.genAudioUrl;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };
  renderTitle = () => {
    let audioElem = (
      <Tooltip title="Harley is generating audio for this message in the background. You will be able to play it when it is ready.">
        <IconButton
          onClick={() => {
            cogoToast.info(
              "Harley is generating audio for this message in the background. You will be able to play it when it is ready."
            );
          }}
        >
          <Iconify icon="icon-park-outline:voice-one" />
        </IconButton>
      </Tooltip>
    );
    if (this.state.audioFileURL) {
      audioElem = <AudioPlayer url={this.state.audioFileURL} />;
    }
    return (
      <Stack direction="row" alignItems={"center"} spacing={0.5}>
        <Typography variant="overline">Harley</Typography>
        {audioElem}
      </Stack>
    );
  };
  render() {
    return (
      <Card
        sx={{
          p: 1,
          m: 1,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Stack>
          {this.renderTitle()}
          <Markdowner
            text={this.props.message.content}
            annotations={[]}
            isAsst={false}
          />
        </Stack>
      </Card>
    );
  }
}

export default WithAPICall(AsstMessage);
